import { CommonResponse, Course, DefaultGetParams, Platform } from 'src/types';

export type MemberCourseAccess = {
  all_courses: boolean;
  course_ids: Course['id'][];
};

export type Member = {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  image: string;
  role_name: string;
  role_id: string;
  created_at: string | null;
  course_access: MemberCourseAccess;
};

export type InvitedMember = Pick<
  Member,
  'email' | 'role_id' | 'role_name' | 'created_at' | 'course_access'
>;

export type MemberDetails = Member & {
  last_active_at: string | null;
  phone?: string;
  daily_activity: Array<{
    date: string;
    time_spent_seconds: number;
  }>;
  total_time_spent: number;
};

export type MembersSortBy = 'first_name' | 'created_at';

export type GetMembersParams = DefaultGetParams<MembersSortBy>;

export type GetMembersResponse = CommonResponse<{
  count: number;
  members: Member[];
}>;

export type GetInvitedMembersResponse = CommonResponse<{
  count: number;
  invited: InvitedMember[];
}>;

export type GetSingleMemberResponse = CommonResponse<MemberDetails>;

export type MemberInviteForm = {
  email: string;
  role_id: string;
  course_access: MemberCourseAccess;
};

export type MemberAssignRoleForm = {
  user_id: Member['id'];
  role_id: string;
};

export type MemberCourseAccessForm = {
  user_id: Member['id'];
  course_access: MemberCourseAccess;
};

export type MemberAcceptInviteForm = {
  invitation_id: string;
};

export const INVITATION_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired',
} as const;

export type InvitationStatus = (typeof INVITATION_STATUS)[keyof typeof INVITATION_STATUS];

export type InvitationDetails = {
  id: string;
  status: InvitationStatus;
  invited_email: string;
  role_name: string;
  created_at: string;
  expires_at: string;
  platform: {
    id: Platform['id'];
    name: Platform['name'];
    icon: string | null;
  };
  inviter: {
    first_name: string;
    last_name: string;
    image: string | null;
  };
};

export type GetInvitationDetailsResponse = CommonResponse<InvitationDetails>;
